import React from "react";

export default function SmokeEffect() {
  return (
    <svg
      className="smoke-svg"
      viewBox="0 0 800 600"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="smokeGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.12)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </radialGradient>

        <filter id="blurFilter">
          <feGaussianBlur stdDeviation="22" />
        </filter>
      </defs>

      {/* Humo 1 */}
      <ellipse
        cx="180"
        cy="420"
        rx="240"
        ry="90"
        fill="url(#smokeGradient)"
        filter="url(#blurFilter)"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0 0; 30 -15; 0 0"
          dur="8s"
          repeatCount="indefinite"
        />
      </ellipse>

      {/* Humo 2 */}
      <ellipse
        cx="620"
        cy="260"
        rx="190"
        ry="70"
        fill="url(#smokeGradient)"
        filter="url(#blurFilter)"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0 0; -20 15; 0 0"
          dur="10s"
          repeatCount="indefinite"
        />
      </ellipse>

      {/* Humo 3 */}
      <ellipse
        cx="450"
        cy="500"
        rx="280"
        ry="100"
        fill="url(#smokeGradient)"
        filter="url(#blurFilter)"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0 0; 15 12; 0 0"
          dur="12s"
          repeatCount="indefinite"
        />
      </ellipse>
    </svg>
  );
}